import * as React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import Image from "../../../ui-components/Image";
import Audio from "../../../ui-components/Audio";

export default function MultipleChoice({ question, onAnswer = () => {} }) {
    const questions = question.questionList || [];
    const [answer, setAnswer] = React.useState(
        Array(questions.length).fill("")
    );

    React.useEffect(() => {
        // reset proceed button
        setAnswer(Array(questions.length).fill(""));
    }, [question, questions.length]);

    const handleSetAnswer = (choice, i) => {
        let ans = [...answer];
        ans[i] = choice;
        setAnswer(ans);
        const canProceed =
            ans.filter((a) => a !== "").length === questions.length;
        onAnswer({
            canProceed,
            answer: ans,
        });
    };

    return (
        <React.Fragment>
            {question.questionImage && (
                <Box
                    sx={{
                        width: "100%",
                        background: "white",
                        pb: 2,
                        pt: 1,
                        px: 1,
                    }}
                    className="image-container"
                >
                    <Image src={question.questionImage} />
                </Box>
            )}
            
            <Box className="choices-container">
                {questions.map((q, i) => (
                    <Box sx={{ mt: 3 }} key={`question-${i}-${Math.random()}`}>
                        <Grid container justifyContent="center">
                            <Grid item sm={12} sx={{ textAlign: "center" }}>
                                {q.audioLink ? (
                <                   Audio audioText={q.audioLink} />
                                ) : (
                                    <Typography variant="qlist_text">
                                        {q.text}
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            gap={1}
                            justifyContent="center"
                            sx={{ mt: 1 }}
                        >
                            {q.choices.map((choice, j) => (
                                <Grid
                                    item
                                    sm={5}
                                    xs={5}
                                    key={`choices-${j}-${Math.random()}`}
                                >
                                    <Button
                                        variant={
                                            answer[i] ===
                                            (choice?.value || choice)
                                                ? "contained"
                                                : "outlined"
                                        }
                                        fullWidth
                                        size="large"
                                        sx={{
                                            fontSize: "1.2rem",
                                            px: 1,
                                            lineHeight: "1.2em",
                                        }}
                                        onClick={() =>
                                            handleSetAnswer(
                                                choice?.value || choice,
                                                i
                                            )
                                        }
                                    >
                                        {choice?.label || choice}
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                ))}
            </Box>
        </React.Fragment>
    );
}
